<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    inputIdentifier: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    inputType: {
      type: String,
      default: "text",
    },
  },
  methods: {
    updateInput(value) {
      this.$emit(`update`, value)
    },
  },
};
</script>

<template>
  <div>
    <label
      class="block mb-2 text-lg text-primary-dark dark:text-primary-light"
      :for="inputIdentifier"
      >{{ label }}</label
    >
    <input
      class="w-full px-5 py-3 border border-ternary-dark dark:border-primary-dark border-opacity-50 text-primary-dark dark:text-black bg-ternary-light dark:bg-ternary-light rounded-md shadow-sm text-md"
      :id="inputIdentifier"
      :name="inputIdentifier"
      :placeholder="label"
      :aria-label="inputIdentifier"
      :value="value"
      :type="inputType"
      v-bind="$attrs"
      @input="updateInput($event.target.value)"
      required
    />
  </div>
</template>

<style lang="scss" scoped></style>
